import React from "react";
import { useCloverStyles } from "../styles/styleClover";

export const LoadingComponent = ({ style }) => {
  
  const classes = useCloverStyles();

  return (
    //------ GIF RECIBE -------//
    <div className="loading-coin loading-wordcoin" style={style}>
      <div className={classes.cloverMain}>
        <div className={classes.cloverContainer}>
          <span className={classes.center}></span>
          <span className={classes.top}></span>
          <span className={classes.right}></span>
          <span className={classes.bottom}></span>
          <span className={classes.left}></span>
        </div>
      </div>
    </div>

    //------ GIF WLD -------//
    // <div className="loading-coin loading-wordcoin" style={style}>
    //   <div className="loading-coin-side heads">
    //     <svg
    //       version="1.1"
    //       id="katman_1"
    //       xmlns="http://www.w3.org/2000/svg"
    //       viewBox="0 0 445.2 315.2"
    //     //   style="enable-background:new 0 0 445.2 315.2;"
    //     >
    //       <path
    //         className="st0"
    //         d="M327.6,115.2c-3-7.5-6.8-14.6-11.3-21.3c-20.3-30-54.7-49.7-93.6-49.7c-62.4,0-112.9,50.6-112.9,112.9
    //         c0,62.4,50.6,113,112.9,113c39,0,73.3-19.7,93.6-49.7c4.5-6.6,8.2-13.7,11.3-21.2c5.2-13,8.1-27.2,8.1-42
    //         C335.6,142.4,332.8,128.2,327.6,115.2z M312.5,145.7H183.2c2-7,5.7-13.2,10.7-18.1c7.6-7.6,18.1-12.3,29.7-12.3H303
    //         C307.9,124.6,311.1,134.8,312.5,145.7z M222.1,66.1c25.7,0,49,10.7,65.6,27.9h-61.3c-17.5,0-33.3,7.1-44.7,18.5
    //         c-8.9,8.9-15.1,20.3-17.4,33.2h-32.5C137.4,100.8,175.7,66.1,222.1,66.1z M222.1,248.4c-46.4,0-84.7-34.7-90.4-79.6h32.5
    //         c5.4,29.4,31.2,51.7,62.2,51.7h61.3C271.2,237.7,247.9,248.4,222.1,248.4z M223.6,199.3c-19.2,0-35.4-12.9-40.4-30.5h129.3
    //         c-1.4,10.9-4.7,21.1-9.5,30.5H223.6z"
    //       />
    //     </svg>
    //   </div>
    //   <div className="loading-coin-side loading-coin-tails">
    //     <svg
    //       version="1.1"
    //       id="katman_1"
    //       xmlns="http://www.w3.org/2000/svg"
    //       viewBox="0 0 445.2 315.2"
    //     //   style="enable-background:new 0 0 445.2 315.2;"
    //     >
    //       <path
    //         className="st0"
    //         d="M327.6,115.2c-3-7.5-6.8-14.6-11.3-21.3c-20.3-30-54.7-49.7-93.6-49.7c-62.4,0-112.9,50.6-112.9,112.9
    //         c0,62.4,50.6,113,112.9,113c39,0,73.3-19.7,93.6-49.7c4.5-6.6,8.2-13.7,11.3-21.2c5.2-13,8.1-27.2,8.1-42
    //         C335.6,142.4,332.8,128.2,327.6,115.2z M312.5,145.7H183.2c2-7,5.7-13.2,10.7-18.1c7.6-7.6,18.1-12.3,29.7-12.3H303
    //         C307.9,124.6,311.1,134.8,312.5,145.7z M222.1,66.1c25.7,0,49,10.7,65.6,27.9h-61.3c-17.5,0-33.3,7.1-44.7,18.5
    //         c-8.9,8.9-15.1,20.3-17.4,33.2h-32.5C137.4,100.8,175.7,66.1,222.1,66.1z M222.1,248.4c-46.4,0-84.7-34.7-90.4-79.6h32.5
    //         c5.4,29.4,31.2,51.7,62.2,51.7h61.3C271.2,237.7,247.9,248.4,222.1,248.4z M223.6,199.3c-19.2,0-35.4-12.9-40.4-30.5h129.3
    //         c-1.4,10.9-4.7,21.1-9.5,30.5H223.6z"
    //       />
    //     </svg>
    //   </div>
    // </div>
  );
};
